export const contrastTextShadow = "0px 0px 2px #000";
